import { GlobalActionsConfigEntity } from "../../domain/globalActionConfig.entity";
import { criteriaToDTO, dtoToCriteria } from "../../../shared/infrastructure/orchestrator.mapper";
import { createEmptyCriteria } from "../../../shared/domain/orchestratedEntity.schema";
import { GlobalActionsConfig } from "../../../../../gen/witbooking/backoffice/orchestrator/globalactions/v1/global_actions_api_pb";

export class GlobalActionsConfigMapper {
  static toDomain(proto: GlobalActionsConfig): GlobalActionsConfigEntity {
    const obj = proto.toObject();
    const criteriaDto = proto.getCriteria();

    const actions: Record<string, string> = {};
    for (const [key, value] of obj.actionsMap) {
      actions[key] = value;
    }

    return {
      id: obj.id,
      active: obj.active,
      ticker: obj.ticker,
      actions,
      criteria: criteriaDto ? dtoToCriteria(criteriaDto) : createEmptyCriteria(),
    };
  }

  static toDomainArray(protos: GlobalActionsConfig[]): GlobalActionsConfigEntity[] {
    return protos.map(proto => GlobalActionsConfigMapper.toDomain(proto));
  }

  static toProto(entity: GlobalActionsConfigEntity): GlobalActionsConfig {
    const config = new GlobalActionsConfig();
    config.setId(entity.id);
    config.setActive(entity.active);
    config.setTicker(entity.ticker);

    const actionsMap = config.getActionsMap();
    for (const [key, value] of Object.entries(entity.actions)) {
      actionsMap.set(key, value);
    }

    if (entity.criteria) {
      config.setCriteria(criteriaToDTO(entity.criteria));
    }

    return config;
  }
}
